module.exports = __webpack_public_path__ + "img/Shortsshare.77976be4.svg";